export enum OpacityToken {
  semiTransparent = '0.08',
  light = '0.16',
  medium = '0.32',
  intense = '0.64',
  semiOpaque = '0.80',
  none = '0.100',
}

export default OpacityToken

export type TOpacityV2 =
  | 'semiTransparent'
  | 'light'
  | 'medium'
  | 'intense'
  | 'semiOpaque'
  | 'none'
